import { gql } from '@apollo/client';

export const AUTH_USER_FRAGMENT = gql`
  fragment AuthUserFields on AuthUserType {
    id
    email
    full_name
    roles
    permissions
  }
`;

export const LOGIN_MUTATION = gql`
  ${AUTH_USER_FRAGMENT}
  mutation Login($input: LoginInput!) {
    login(input: $input) {
      access_token
      expires_in
      user {
        ...AuthUserFields
      }
    }
  }
`;

export const LOGOUT_MUTATION = gql`
  mutation Logout {
    logout {
      ok
    }
  }
`;

export const ME_QUERY = gql`
  ${AUTH_USER_FRAGMENT}
  query Me {
    me {
      ...AuthUserFields
    }
  }
`;

export const LOCK_SESSION_MUTATION = gql`
  mutation LockSession {
    lockSession {
      ok
    }
  }
`;

export const UNLOCK_SESSION_MUTATION = gql`
  mutation UnlockSession {
    unlockSession {
      ok
    }
  }
`;
